export default "__VITE_ASSET__rxFLtmVl__"